export const HTS_NUMBER_MISSING = 'HTS_NUMBER_MISSING';
export const HTS_NUMBER_WRONG_LENGTH = 'HTS_NUMBER_WRONG_LENGTH';
export const HTS_COUNTRY_OF_ORIGIN_MISSING = 'COUNTRY_OF_ORIGIN_MISSING';
export const HTS_COUNTRY_OF_ORIGIN_INVALID = 'COUNTRY_OF_ORIGIN_INVALID';

export const STATE_OF_ORIGIN_MISSING = 'STATE_OF_ORIGIN_MISSING';
export const STATE_OF_ORIGIN_INVALID = 'STATE_OF_ORIGIN_INVALID;';

export const BILL_CARRIER_MISSING = 'BILL_CARRIER_MISSING';
export const BILL_NUMBER_MISSING = 'BILL_NUMBER_MISSING';
export const MASTER_BILL_NUMBER_MISSING = 'MASTER_BILL_NUMBER_MISSING';
export const MASTER_AIR_BILL_NUMBER_MISSING = 'MASTER_AIR_BILL_NUMBER_MISSING';
export const MASTER_BILL_CARRIER_MISSING = 'MASTER_BILL_CARRIER_MISSING';
export const MASTER_AIR_BILL_PREFIX_MISSING = 'MASTER_AIR_BILL_PREFIX_MISSING';
export const MASTER_BILL_CARRIER_WRONG_LENGTH = 'MASTER_BILL_CARRIER_WRONG_LENGTH';
export const MASTER_AIR_BILL_PREFIX_WRONG_LENGTH = 'MASTER_AIR_BILL_PREFIX_WRONG_LENGTH';
export const MASTER_BILL_TOO_LONG = 'MASTER_BILL_TOO_LONG';
export const MASTER_AIR_BILL_NUMBER_TOO_LONG = 'MASTER_AIR_BILL_NUMBER_TOO_LONG';
export const HOUSE_BILL_CARRIER_MISSING = 'HOUSE_BILL_CARRIER_MISSING';
export const HOUSE_AIR_BILL_PREFIX_MISSING = 'HOUSE_AIR_BILL_PREFIX_MISSING';
export const HOUSE_BILL_NUMBER_MISSING = 'HOUSE_BILL_NUMBER_MISSING';
export const HOUSE_AIR_BILL_NUMBER_MISSING = 'HOUSE_AIR_BILL_NUMBER_MISSING';
export const HOUSE_BILL_CARRIER_WRONG_LENGTH = 'HOUSE_BILL_CARRIER_WRONG_LENGTH';
export const HOUSE_AIR_BILL_PREFIX_WRONG_LENGTH = 'HOUSE_AIR_BILL_PREFIX_WRONG_LENGTH';
export const HOUSE_BILL_TOO_LONG = 'HOUSE_BILL_TOO_LONG';
export const HOUSE_AIR_BILL_NUMBER_TOO_LONG = 'HOUSE_AIR_BILL_NUMBER_TOO_LONG';
export const COMPANY_NAME_MALFORMED = 'COMPANY_NAME_MALFORMED';
export const CITY_MALFORMED = 'CITY_MALFORMED';
export const STREET_ADDRESS_MALFORMED = 'STREET_ADDRESS_MALFORMED';
export const QUALIFIER_MALFORMED = 'QUALIFIER_MALFORMED';
export const IDENTIFIER_MALFORMED = 'IDENTIFIER_MALFORMED';
export const POSTAL_CODE_MALFORMED = 'POSTAL_CODE_MALFORMED';
export const TRANSPORTATION_MODE_MISSING = 'TRANSPORTATION_MODE_MISSING';
export const IMPORTER_MISSING = 'IMPORTER_MISSING';
export const ARRIVAL_DATE_MISSING = 'ARRIVAL_DATE_MISSING';
export const ARRIVAL_DATE_TOO_EARLY = 'ARRIVAL_DATE_TOO_EARLY';
export const LOCATION_MISSING = 'LOCATION_MISSING';
export const PORT_OF_ENTRY_MISSING = 'PORT_OF_ENTRY_MISSING';
export const PORT_OF_UNLADING_MISSING = 'PORT_OF_UNLADING_MISSING';
export const TRIP_MISSING = 'TRIP_MISSING';
export const FLIGHT_NUMBER_MISSING = 'FLIGHT_NUMBER_MISSING'; // only on frontend
export const VESSEL_NAME_MISSING = 'VESSEL_NAME_MISSING';
export const BOND_TYPE_MISSING = 'BOND_TYPE_MISSING';
export const BOND_SURETY_CODE_MISSING = 'BOND_SURETY_CODE_MISSING';
export const BOND_REFERENCE_NUMBER_MALFORMED = 'BOND_REFERENCE_NUMBER_MALFORMED';
export const BOND_REQUEST_PORT_CODE_MISSING = 'BOND_REQUEST_PORT_CODE_MISSING';
export const BOND_REQUEST_AMOUNT_MISSING = 'BOND_REQUEST_AMOUNT_MISSING';
export const SINGLE_BOND_REQUEST_FORBIDDEN = 'SINGLE_BOND_REQUEST_FORBIDDEN';
export const BOND_REQUEST_NOT_ALLOWED_FOR_INFORMAL_ENTRY = 'BOND_REQUEST_NOT_ALLOWED_FOR_INFORMAL_ENTRY';
export const FORMAL_ENTRY_REQUIRED_FOR_CBP_ASSIGNED_NUMBER = 'FORMAL_ENTRY_REQUIRED_FOR_CBP_ASSIGNED_NUMBER';
export const STATE_OF_DESTINATION_MISSING = 'STATE_OF_DESTINATION_MISSING';
export const MISSING_CANADA_STATE = 'MISSING_CANADA_STATE';
export const MISSING_COUNTRY = 'MISSING_COUNTRY';
export const MISSING_CITY = 'MISSING_CITY';
export const IT_NUMBER_MALFORMED = 'IT_NUMBER_MALFORMED';
export const IT_DATE_LATER_THAN_ENTRY_DATE = 'IT_DATE_LATER_THAN_ENTRY_DATE';
export const VESSEL_NAME_TOO_LONG = 'VESSEL_NAME_TOO_LONG';
export const PAYER_UNIT_NUMBER_MISSING = 'PAYER_UNIT_NUMBER_MISSING';
export const PAYER_UNIT_NUMBER_MALFORMED = 'PAYER_UNIT_NUMBER_MALFORMED';
export const FORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_SMALL = 'FORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_SMALL'; // only on frontend
export const FORMAL_SHIPMENT_TYPE_CN_ENTERED_VALUE_TOO_SMALL = 'FORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_SMALL'; // only on frontend
export const INFORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG = 'INFORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG'; // only on frontend
export const INFORMAL_SHIPMENT_TYPE_CN_ENTERED_VALUE_TOO_BIG = 'INFORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG'; // only on frontend
export const FORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_SMALL_DESKTOP = 'FORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_SMALL_DESKTOP'; // only on frontend
export const INFORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG_DESKTOP = 'INFORMAL_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG_DESKTOP'; // only on frontend
export const INFORMAL_NON_DRAFT_ES_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG = 'INFORMAL_NON_DRAFT_ES_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG'; // only on frontend
export const INFORMAL_NON_DRAFT_ES_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG_DESKTOP =
  'INFORMAL_NON_DRAFT_ES_SHIPMENT_TYPE_ENTERED_VALUE_TOO_BIG_DESKTOP'; // only on frontend
export const CURRENCY_IS_NOT_AVAILABLE = 'CURRENCY_IS_NOT_AVAILABLE';
export const MISSING_ATTACHED_DOCUMENT_BILL_OF_LADING = 'MISSING_ATTACHED_DOCUMENT_BILL_OF_LADING'; // only on frontend
export const MISSING_ATTACHED_DOCUMENT_INVOICE = 'MISSING_ATTACHED_DOCUMENT_INVOICE'; // only on frontend
export const MISSING_ATTACHED_DOCUMENT_POA = 'MISSING_ATTACHED_DOCUMENT_POA'; // only on frontend
export const MISSING_ATTACHED_DOCUMENT_PUN = 'MISSING_ATTACHED_DOCUMENT_PUN'; // only on frontend
export const SCAN_FAIL_FILE = 'SCAN_FAIL_FILE'; // only on frontend
export const FILE_SIZE_TO_BIG_AFTER_SCAN = 'FILE_SIZE_TO_BIG_AFTER_SCAN'; // only on frontend
export const ACH_METHOD_NOT_ALLOWED_WITH_PUN = 'ACH_METHOD_NOT_ALLOWED_WITH_PUN'; // only on frontend
export const ACH_METHOD_NOT_ALLOWED_WITHOUT_PUN = 'ACH_METHOD_NOT_ALLOWED_WITHOUT_PUN'; // only on frontend

export const SHIPMENT_MISSING = 'SHIPMENTS_MISSING';
export const EXPORT_DATE_MISSING = 'EXPORT_DATE_MISSING';
export const EXPORT_DATE_LATER_THAN_ARRIVAL_DATE = 'EXPORT_DATE_LATER_THAN_ARRIVAL_DATE';
export const FOREIGN_PORT_MISSING = 'FOREIGN_PORT_MISSING';
export const IT_DATE_MISSING = 'IT_DATE_MISSING';
export const IT_NUMBER_MISSING = 'IT_NUMBER_MISSING';
export const BUYER_MISSING = 'BUYER_MISSING';
export const SELLER_MISSING = 'SELLER_MISSING';
export const CONSIGNEE_MISSING = 'CONSIGNEE_MISSING';
export const CONSOLIDATOR_MISSING = 'CONSOLIDATOR_MISSING';
export const SHIP_TO_MISSING = 'SHIP_TO_MISSING';
export const FREIGHT_COST_MISSING = 'FREIGHT_COST_MISSING';
export const FREIGHT_COST_LESS_THAN_LINES_COUNT = 'FREIGHT_COST_LESS_THAN_LINES_COUNT';
export const MASTER_BILL_CARRIER_MALFORMED = 'MASTER_BILL_CARRIER_MALFORMED';
export const MASTER_BILL_NUMBER_MALFORMED = 'MASTER_BILL_NUMBER_MALFORMED';
export const HOUSE_BILL_CARRIER_MALFORMED = 'HOUSE_BILL_CARRIER_MALFORMED';
export const HOUSE_BILL_NUMBER_MALFORMED = 'HOUSE_BILL_NUMBER_MALFORMED';

export const INVOICE_MISSING = 'INVOICES_MISSING';
export const INVOICE_NUMBER_MISSING = 'INVOICE_NUMBER_MISSING';
export const INVOICE_MANUFACTURER_MISSING = 'INVOICE_MANUFACTURER_MISSING';
export const MANUFACTURER_EXPECTED_TO_BE_CANADIAN = 'MANUFACTURER_EXPECTED_TO_BE_CANADIAN';
export const QUANTITY_MISSING = 'QUANTITY_MISSING';
export const QUANTITY_UNIT_MISSING = 'QUANTITY_UNIT_MISSING';
export const INVOICE_NUMBER_MALFORMED = 'INVOICE_NUMBER_MALFORMED';
export const INVOICE_OCR_STATE_NOT_REVIEWED = 'INVOICE_OCR_STATE_NOT_REVIEWED';

export const LINES_MISSING = 'LINES_MISSING';
export const SPECIAL_CHAPTER_MISSING = 'SPECIAL_CHAPTER_MISSING';
export const COUNTRY_OF_EXPORT_MISSING = 'COUNTRY_OF_EXPORT_MISSING';
export const GROSS_WEIGHT_MISSING = 'GROSS_WEIGHT_MISSING';
export const QUANTITY1_MISSING = 'QUANTITY1_MISSING';
export const QUANTITY2_MALFORMED = 'QUANTITY2_MALFORMED';
export const QUANTITY3_MALFORMED = 'QUANTITY3_MALFORMED';
export const UNIT1_MISSING = 'UNIT1_MISSING';
export const VALUE_MISSING = 'VALUE_MISSING';
export const HTS_DOES_NOT_EXIST = 'HTS_DOES_NOT_EXIST';
export const SPECIAL_CHAPTER_HTS_DOES_NOT_EXIST = 'SPECIAL_CHAPTER_HTS_DOES_NOT_EXIST';
export const BOND_REQUEST_NOT_SENT = 'BOND_REQUEST_NOT_SENT';
export const MISSING_ADDRESS = 'MISSING_ADDRESS';
export const MISSING_ADDRESS_PARTS = 'MISSING_ADDRESS_PARTS';
export const MISSING_COMPANY_NAME = 'MISSING_COMPANY_NAME';
export const MISSING_IDENTIFIER_QUALIFIER = 'MISSING_IDENTIFIER_QUALIFIER';
export const MISSING_IDENTIFIER = 'MISSING_IDENTIFIER';
export const WRONG_IDENTIFIER_FORMAT = 'WRONG_IDENTIFIER_FORMAT';
export const MISSING_DATE_OF_BIRTH = 'MISSING_DATE_OF_BIRTH';
export const WRONG_IDENTIFIER_LENGTH = 'WRONG_IDENTIFIER_LENGTH';
export const MISSING_STATE = 'MISSING_STATE';
export const MISSING_POSTAL_CODE = 'MISSING_POSTAL_CODE';
export const PHONE_MISSING = 'PHONE_MISSING';
export const EMAIL_MISSING = 'EMAIL_MISSING';
// #13384: draft entry of a company with the classification assistant tag has a line without HTS verification
export const HTS_NOT_VERIFIED = 'HTS_NOT_VERIFIED';
